import { useEffect, useState } from "react";
import { api, type Me } from "../api.ts";

export function SignIn({ me, onSignedIn }: { me: Me; onSignedIn: () => void }) {
  const [devMembers, setDevMembers] = useState<{ id: string; name: string; role: string; isAdmin: boolean }[]>([]);
  const search = new URLSearchParams(window.location.search);
  const refused = search.has("signin");
  // errors from the OAuth server (connecting Claude) land here too, with a description
  const oauthError = /^(invalid_|unsupported_|client_|unauthorized_client)/.test(search.get("error") ?? "")
    ? search.get("error_description") || search.get("error")
    : null;

  useEffect(() => {
    if (me.signIn.dev) api.devMembers().then(setDevMembers, () => {});
  }, [me.signIn.dev]);

  const notOnTeam = me.state === "not-on-team";

  return (
    <div className="signin">
      <div className="signin-card">
        <p className="eyebrow">Buy.OEM &middot; B2B testing pass</p>
        <h1>Board</h1>
        {notOnTeam ? (
          <>
            <p>
              You&rsquo;re signed in as <b>{me.email}</b>, but that account isn&rsquo;t on the board yet. Ask an admin to add you, then
              sign in again.
            </p>
            <div className="row" style={{ justifyContent: "flex-start" }}>
              <button className="btn" onClick={() => api.signOut().then(onSignedIn)}>
                Sign out
              </button>
            </div>
          </>
        ) : (
          <>
            <p>Sign in with your work Microsoft account. Only people on the team can open the board.</p>
            {refused && (
              <div className="msg err">
                {oauthError
                  ? `Couldn't connect: ${oauthError}. Start again from Claude.`
                  : "That account isn’t on the board. Use your work account, or ask an admin to add you."}
              </div>
            )}
            {me.signIn.microsoft ? (
              <button className="btn primary signin-ms" onClick={() => api.signInMicrosoft()}>
                Sign in with Microsoft
              </button>
            ) : (
              <div className="hint" style={{ marginTop: 0 }}>
                Microsoft sign-in isn&rsquo;t configured on this server yet (see README &rarr; Microsoft sign-in).
              </div>
            )}
          </>
        )}

        {me.signIn.dev && !notOnTeam && (
          <div className="dev-login">
            <label>Development only &mdash; sign in as</label>
            <div className="asg-grid">
              {devMembers.map((m) => (
                <button key={m.id} className="btn" onClick={() => api.devLogin(m.id).then(onSignedIn)}>
                  {m.name} <span className="n">{m.isAdmin ? "admin" : m.role}</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
